// Centralized date helpers for the app's business timezone.
// The Dominican Republic (America/Santo_Domingo) is fixed at UTC-4 (no DST).
// Using toISOString() returns UTC dates, which roll over a day early/late for
// AST users; these helpers always resolve the calendar date in AST instead.
export const APP_TZ = "America/Santo_Domingo";

const _dtf = new Intl.DateTimeFormat("en-CA", {
  timeZone: APP_TZ,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

// Returns the current calendar date in AST as "YYYY-MM-DD".
export function todayAST(d = new Date()) {
  return _dtf.format(d);
}

// Returns the current month in AST as "YYYY-MM".
export function monthAST(d = new Date()) {
  return todayAST(d).slice(0, 7);
}

const _tf = new Intl.DateTimeFormat("en-GB", {
  timeZone: APP_TZ,
  hour: "2-digit",
  minute: "2-digit",
  hour12: false,
});

// Returns the current time-of-day in AST as "HH:MM".
export function nowTimeAST(d = new Date()) {
  return _tf.format(d);
}

// Formats a local Date object as "YYYY-MM-DD" using its own calendar fields
// (used for react-day-picker cells, which are timezone-agnostic).
export function fmtDate(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
